<template>
  <vs-col class="reset-alert-height" v-if="Boolean(selected)">
    <vs-alert
      :active="Boolean(selected)"
      color="dark"
    >
    <h3>{{selected.NOMECOMERCIAL}}</h3>
    </vs-alert>
  </vs-col>
</template>

<script>
import { getStepsInformation } from "../helpers/storage";

export default {
  name: "SelectedCourseBox",
  data: () => ({
    selected: null,
  }),
  created() {
    const stepsData = getStepsInformation();
    if (stepsData.courseSimulate) this.selected = stepsData.courseSimulate;
  },
};
</script>

<style>
.reset-alert-height > div {
  height: initial !important;
}
</style>
